import { render, staticRenderFns } from "./ScaleProductsSupportedPatterns.vue?vue&type=template&id=1946a868&scoped=true"
var script = {}
import style0 from "./ScaleProductsSupportedPatterns.vue?vue&type=style&index=0&id=1946a868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1946a868",
  null
  
)

export default component.exports